
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import SkillSingleInputPlayground from '../../components/Skill/SingleInputOutput/SkillSingleInputPlayground';
import { GPT_3_TOKEN_LENGTH } from '../../constants/gpt3';
import { FIX_SKILLS, SKILL_FIX_TEXT, getFourRandomSkills } from '../../constants/skills';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { SkillProvider } from '../../utils/SkillContext';
const SkillBulletPointsExtraction = ({ otherServices }: any) => {
    const { t, lang } = useTranslation('skill-text');
    const skillsGroup = FIX_SKILLS;
    const maxLength = 500 * GPT_3_TOKEN_LENGTH;
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_fix_text' description='meta_description_skill_fix_text'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_FIX_TEXT} skillExamples={[]} skillGroup={skillsGroup}>
              <SkillSingleInputPlayground maxLength={maxLength} showDiff></SkillSingleInputPlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillBulletPointsExtraction;

    async function __Next_Translate__getStaticProps__19bb2fd5b63__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/fix/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b63__ as getStaticProps }
  